module.exports = __webpack_public_path__ + "img/dc_logo_b.4e5692d4.png";